/**
 * 埋点上报结构
 * event_type: 事件类型 click / show
 * event_name: 事件名称 CLICK_MORE_RANK 或 点击更多排行
 * event_data: 事件数据 {sex: 0}
 */
import {
 reportktv,
 reportHmt,
 reportVaddUser,
 reportEvent,
} from './log';

export function sendLog(logData) {
  if (!logData) return;
  if (this) {
    if (this.$route) {
        logData.str1 = this.$route.path
    }
  }
  if (logData.event_mode == 'eventVod') { // 用这个接口https:// log6.ktvsky.com/vod/event上报的
    reportEvent({ ...logData.event_data })
    return
  }
  reportktv({ ...logData });
  reportHmt({ ...logData });
  reportVaddUser({ ...logData });
}
